<template lang="pug">
  el-menu-item(
    index='/smart_cards'
    v-if=`showItemDynamically(user, dynamicViewsConstants.resource_names.SMART_CARD, ['index'])`
  )
    .img-wrapper
      img(src="@src/assets/sidebar/cost_centers.svg")
    router-link.sub-menu-link(to="/smart_cards")
      span  {{ $t('sidebar.smart_cards') }}
</template>

<script>
import { general } from "@src/services/dynamicViews/general";
import { dynamicViewsConstants } from "@src/constants";
import { mapState } from "vuex";


export default {
  name: "SmartCardsItem",
  mixins: [general],

  computed: {
    ...mapState("auth", ["user"]),
  },

  data() {
    return {
      dynamicViewsConstants
    }
  }
}
</script>
